import { useAppSelector, useGetUserWishlists } from '@pkg/hooks';

import { useGetYatPageLinks } from '../sections/LinksSection/hooks';
import { useProfileCollectibles } from '../sections/NFTSection/hooks';

import { useIsPreview } from './useIsPreview';

export const usePrefetchSections = () => {
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const yatsSectionEnabled = useAppSelector((state) => state.featureFlags.features.yatsPortfolio);
    const userId = useAppSelector((state) => state.yatPage.user_id) || '';
    const isPreview = useIsPreview();

    const eid = useAppSelector((state) => state.yatPage.eid);

    const { data: pageItemData, isLoading: isLoadingLinks } = useGetYatPageLinks({ eid: eid || '' });

    const { itemCount, isLoading: isLoadingItems } = useProfileCollectibles();
    const { data: wishlistData, isLoading: isLoadingWishlists } = useGetUserWishlists({
        userId,
        isOwner: isPageOwner && !isPreview,
    });

    const isLoading = !eid || isLoadingWishlists || isLoadingItems || isLoadingLinks;
    const privateView = isPageOwner && !isPreview;

    const wishlistsEnabled = privateView || Boolean(wishlistData?.pages?.[0]?.paging?.total);
    const linksEnabled = privateView || Boolean(pageItemData?.pages?.[0]?.paging?.total);

    const emptyProfile = !wishlistsEnabled && !linksEnabled && !yatsSectionEnabled;
    const nftsEnabled = privateView || Boolean(itemCount) || emptyProfile;

    return {
        isLoading,
        wishlistsEnabled,
        nftsEnabled,
        linksEnabled,
        isLoadingItems,
        isLoadingWishlists,
        isLoadingLinks,
    };
};
